import { createRoot } from "react-dom/client";
import { useEffect } from "react";
import { Router as WouterRouter, Switch, Route, useLocation } from "wouter";
import "./index.css";

import { HelpCenter } from "./pages/HelpCenter";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { PublicSecurity } from "./pages/PublicSecurity";
import { FieldManual } from "./pages/FieldManual";
import { MissionDebrief } from "./pages/MissionDebrief";
import { CategoryGuide } from "./pages/CategoryGuide";

const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

function NavigationCatchAll() {
  const [location] = useLocation();
  useEffect(() => {
    const target = (basePath + location).replace(/\/\/$/, "/") || "/";
    if (window.location.pathname !== target) {
      window.location.href = target;
    }
  }, [location]);
  return null;
}

function PublicApp() {
  return (
    <WouterRouter base={basePath}>
      <Switch>
        <Route path="/help" component={HelpCenter} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms" component={Terms} />
        <Route path="/security" component={PublicSecurity} />
        <Route path="/field-manual" component={FieldManual} />
        <Route path="/mission-debrief" component={MissionDebrief} />
        <Route path="/what-is-autonomous-ai-growth-platform" component={CategoryGuide} />
        <Route component={NavigationCatchAll} />
      </Switch>
    </WouterRouter>
  );
}

createRoot(document.getElementById("root")!).render(<PublicApp />);
